"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TimePickerDefaultProps = exports.TimePicker = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _CalendarTime = require("./helpers/CalendarTime");

var _Button = _interopRequireWildcard(require("../../elements/Button"));

var _PopperMenu = _interopRequireDefault(require("../PopperMenu"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var TimePicker = function TimePicker(props) {
  var classNames = props.classNames,
      disabled = props.disabled,
      children = props.children,
      onClickOK = props.onClickOK,
      onClickCancel = props.onClickCancel;

  var _useState = (0, _react.useState)(props.date),
      _useState2 = _slicedToArray(_useState, 2),
      myDate = _useState2[0],
      setMyDate = _useState2[1];

  var refPopperMenu = (0, _react.useRef)(null);
  var dayClassNames = (0, _classnames.default)({
    'calendar-component__picker': true,
    'calendar-component__timepicker': true
  }, classNames);
  var buttonDivClassNames = (0, _classnames.default)('calendar-component__picker__buttons', 'calendar-component__timepicker__buttons');
  var labelComponentClassNames = (0, _classnames.default)('calendar-component__picker__label', 'calendar-component__timepicker__label');
  var buttonOKComponentClassNames = (0, _classnames.default)('calendar-component__picker__button', 'calendar-component__picker__button-ok', 'calendar-component__timepicker__button', 'calendar-component__timepicker__button-ok');
  var buttonCancelComponentClassNames = (0, _classnames.default)('calendar-component__picker__button', 'calendar-component__picker__button-cancel', 'calendar-component__timepicker__button', 'calendar-component__timepicker__button-cancel');
  var popperContentClassNames = (0, _classnames.default)('calendar-component__picker__popperContent', 'calendar-component__timepicker__popperContent');

  var _onClickOK = function _onClickOK(event) {
    if (onClickOK) {
      onClickOK(event, myDate);
    }

    if (refPopperMenu.current) {
      refPopperMenu.current.togglePopperVisibility();
    }
  };

  var _onClickCancel = function _onClickCancel(event) {
    if (onClickCancel) {
      onClickCancel(event);
    }

    if (refPopperMenu.current) {
      refPopperMenu.current.togglePopperVisibility();
    }
  };

  var _onChange = function _onChange(date) {
    setMyDate(date);
  };

  var labelComponent = /*#__PURE__*/_react.default.createElement("div", {
    className: labelComponentClassNames
  }, children);

  var timePicker = /*#__PURE__*/_react.default.createElement("div", {
    className: dayClassNames
  }, /*#__PURE__*/_react.default.createElement(_CalendarTime.CalendarTime, {
    date: myDate,
    onChange: _onChange
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: buttonDivClassNames
  }, /*#__PURE__*/_react.default.createElement(_Button.ButtonText, {
    classNames: buttonCancelComponentClassNames,
    onClick: _onClickCancel
  }, "Cancel"), /*#__PURE__*/_react.default.createElement(_Button.default, {
    classNames: buttonOKComponentClassNames,
    onClick: _onClickOK
  }, "OK")));

  return /*#__PURE__*/_react.default.createElement(_PopperMenu.default, {
    menuPlacement: "bottom",
    arrow: true,
    disabled: disabled,
    referenceElement: labelComponent,
    classNamesPopperContent: popperContentClassNames,
    autoCloseOnClick: false,
    ref: refPopperMenu
  }, timePicker);
};

exports.TimePicker = TimePicker;
TimePicker.propTypes = {
  classNames: _propTypes.default.any.isRequired,
  disabled: _propTypes.default.bool.isRequired,
  date: _propTypes.default.instanceOf(Date).isRequired,
  children: _propTypes.default.node.isRequired,
  onClickCancel: _propTypes.default.func.isRequired,
  onClickOK: _propTypes.default.func.isRequired
};
var TimePickerDefaultProps = {
  classNames: '',
  disabled: false
};
exports.TimePickerDefaultProps = TimePickerDefaultProps;
TimePicker.defaultProps = TimePickerDefaultProps;
var _default = TimePicker;
exports.default = _default;